// extracted by mini-css-extract-plugin
module.exports = {"title":"Proposals_title__CflS7","proposalsWrapper":"Proposals_proposalsWrapper__cI8lL"};